import React from 'react';
import SwaggerUI from 'swagger-ui-react';

import { useFbmSwaggerSpecQuery } from 'shared/hooks/fbm/useFbmSwaggerSpecQuery';

import 'swagger-ui-react/swagger-ui.css';

function FBMApiDocs() {
    const { data: spec, isError, isLoading } = useFbmSwaggerSpecQuery();

    if (isLoading) {
        return (
            <div className="flex items-center justify-center h-screen">
                <p className="text-gray-500">Loading API documentation...</p>
            </div>
        );
    }

    if (isError) {
        return (
            <div className="flex items-center justify-center h-screen">
                <p className="text-red-600">Unable to load API documentation. Please try refreshing the page.</p>
            </div>
        );
    }

    return (
        <div className="text-left">
            <SwaggerUI spec={spec} supportedSubmitMethods={['get']} />
        </div>
    );
}

export { FBMApiDocs };
